/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { OrderDetailResponse } from '../models';
// @ts-ignore
import type { OrderListResponse } from '../models';
// @ts-ignore
import type { OrderResponse } from '../models';
// @ts-ignore
import type { RecentOrderResponse } from '../models';
/**
 * OrdersApi - axios parameter creator
 * @export
 */
export const OrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 특정 주문의 상세 정보를 조회합니다
         * @summary 주문 상세 조회
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderById: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderById', 'orderId', orderId)
            const localVarPath = `/api/v1/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 주문 상세 조회 (v2)
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDetail: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderDetail', 'orderId', orderId)
            const localVarPath = `/api/v1/orders/{orderId}/detail`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 사용자의 주문 목록을 조회합니다
         * @summary 주문 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 최근 주문들을 조회합니다
         * @summary 최근 주문 조회
         * @param {string} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentOrders: async (limit?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/recent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrdersApi - functional programming interface
 * @export
 */
export const OrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 특정 주문의 상세 정보를 조회합니다
         * @summary 주문 상세 조회
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderById(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderById(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getOrderById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 주문 상세 조회 (v2)
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderDetail(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderDetail(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getOrderDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 사용자의 주문 목록을 조회합니다
         * @summary 주문 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 최근 주문들을 조회합니다
         * @summary 최근 주문 조회
         * @param {string} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecentOrders(limit?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecentOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentOrders(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getRecentOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrdersApi - factory interface
 * @export
 */
export const OrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrdersApiFp(configuration)
    return {
        /**
         * 특정 주문의 상세 정보를 조회합니다
         * @summary 주문 상세 조회
         * @param {OrdersApiGetOrderByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderById(requestParameters: OrdersApiGetOrderByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.getOrderById(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 주문 상세 조회 (v2)
         * @param {OrdersApiGetOrderDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDetail(requestParameters: OrdersApiGetOrderDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderDetailResponse> {
            return localVarFp.getOrderDetail(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 사용자의 주문 목록을 조회합니다
         * @summary 주문 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders(options?: RawAxiosRequestConfig): AxiosPromise<OrderListResponse> {
            return localVarFp.getOrders(options).then((request) => request(axios, basePath));
        },
        /**
         * 최근 주문들을 조회합니다
         * @summary 최근 주문 조회
         * @param {OrdersApiGetRecentOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentOrders(requestParameters: OrdersApiGetRecentOrdersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<RecentOrderResponse> {
            return localVarFp.getRecentOrders(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrdersApi - interface
 * @export
 * @interface OrdersApi
 */
export interface OrdersApiInterface {
    /**
     * 특정 주문의 상세 정보를 조회합니다
     * @summary 주문 상세 조회
     * @param {OrdersApiGetOrderByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    getOrderById(requestParameters: OrdersApiGetOrderByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse>;

    /**
     * 
     * @summary 주문 상세 조회 (v2)
     * @param {OrdersApiGetOrderDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    getOrderDetail(requestParameters: OrdersApiGetOrderDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderDetailResponse>;

    /**
     * 사용자의 주문 목록을 조회합니다
     * @summary 주문 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    getOrders(options?: RawAxiosRequestConfig): AxiosPromise<OrderListResponse>;

    /**
     * 최근 주문들을 조회합니다
     * @summary 최근 주문 조회
     * @param {OrdersApiGetRecentOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    getRecentOrders(requestParameters?: OrdersApiGetRecentOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecentOrderResponse>;

}

/**
 * Request parameters for getOrderById operation in OrdersApi.
 * @export
 * @interface OrdersApiGetOrderByIdRequest
 */
export interface OrdersApiGetOrderByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof OrdersApiGetOrderById
     */
    readonly orderId: string
}

/**
 * Request parameters for getOrderDetail operation in OrdersApi.
 * @export
 * @interface OrdersApiGetOrderDetailRequest
 */
export interface OrdersApiGetOrderDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof OrdersApiGetOrderDetail
     */
    readonly orderId: string
}

/**
 * Request parameters for getRecentOrders operation in OrdersApi.
 * @export
 * @interface OrdersApiGetRecentOrdersRequest
 */
export interface OrdersApiGetRecentOrdersRequest {
    /**
     * 
     * @type {string}
     * @memberof OrdersApiGetRecentOrders
     */
    readonly limit?: string
}

/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
export class OrdersApi extends BaseAPI implements OrdersApiInterface {
    /**
     * 특정 주문의 상세 정보를 조회합니다
     * @summary 주문 상세 조회
     * @param {OrdersApiGetOrderByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public getOrderById(requestParameters: OrdersApiGetOrderByIdRequest, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).getOrderById(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 주문 상세 조회 (v2)
     * @param {OrdersApiGetOrderDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public getOrderDetail(requestParameters: OrdersApiGetOrderDetailRequest, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).getOrderDetail(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 사용자의 주문 목록을 조회합니다
     * @summary 주문 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public getOrders(options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).getOrders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 최근 주문들을 조회합니다
     * @summary 최근 주문 조회
     * @param {OrdersApiGetRecentOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public getRecentOrders(requestParameters: OrdersApiGetRecentOrdersRequest = {}, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).getRecentOrders(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
}

